import { useState } from "react";
import leftSide from "../../../assets/Home-Page-Assets/left-side.png";
import tagline from "../../../assets/Home-Page-Assets/It only gets better....png";
import BelpowerImage from "../../../assets/Home-Page-Assets/Belpower.png";
import PromoImage from "../../../assets/Home-Page-Assets/promo.png";
import BelsoftAcademyImage from "../../../assets/Home-Page-Assets/belsoftacademy.png";
import Button from "../../../components/Buttons/Button";
import Carousel from "../../../components/Carousel/Carousel";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";

const carouselSlides = [
  {
    title: "Get In Touch With us Today!",
    description:
      "We create groundbreaking digital solutions for brands by seamlessly integrating design and cutting-edge technology.",
    buttonText: "Contact Us",
    buttonLink: "https://www.belsoftsystems.com/hire-us",
    image: PromoImage,
  },
  {
    title: "BelPower is Live!",
    description:
      "Fast and secure bill payments platform for airtime, data, electricity and cable TV.",
    buttonText: "Sign Up Now!",
    buttonLink: "https://www.belpower.ng/",
    image: BelpowerImage,
  },
  {
    title: "New Cohort Starting Soon",
    description:
      "At Belsoft Academy, we're committed to empowering individuals with the skills they need to thrive in the digital age.",
    buttonText: "Enroll Now",
    buttonLink: "https://www.belsoftacademy.com/",
    image: BelsoftAcademyImage,
  },
];

const boxes = [
  {
    id: 1,
    title: "About Us",
    content:
      "We create groundbreaking digital solutions for brands by seamlessly integrating design and cutting-edge technology.",
  },
  {
    id: 2,
    title: "Our Vision",
    content:
      "Our vision is to innovate and lead in technology integration, providing transformative digital experiences.",
  },
  {
    id: 3,
    title: "Our Mission",
    content:
      "Our mission is to empower brands through cutting-edge technology and exceptional design, fostering growth and success.",
  },
];

const Hero = () => {
  const [expandedBoxIndex, setExpandedBoxIndex] = useState(null);

  const handleExpand = (index) => {
    setExpandedBoxIndex(expandedBoxIndex === index ? null : index);
  };

  return (
    <div className="hero">
      <div className="container">
        <div className="left-side">
          <img src={leftSide} alt="Belsoft Systems decorative graphic" />
        </div>
        <div className="right-side">
          <div className="hero-banner">
            <div className="hero-content">
              <div className="title">
                <h1>BelSoft</h1>
                <h3>SYSTEMS</h3>
              </div>
              <div className="motto">
                <img src={tagline} alt="It only gets better..." />
              </div>
            </div>
          </div>

          <div className="description">
            <div className="container">
              <div className="desc">
                <p>
                  We create groundbreaking digital solutions for brands by
                  seamlessly integrating design and cutting-edge technology.
                </p>
                <Button text="Our Work" page="/case-studies" />
              </div>
              <div className="hero-dropdowns">
                {boxes.map((box, index) => {
                  const isExpanded = expandedBoxIndex === index;
                  const panelId = `hero-panel-${box.id}`;

                  return (
                    <div key={box.id} className="dropdown">
                      <button
                        type="button"
                        className="dropdown-header"
                        onClick={() => handleExpand(index)}
                        aria-expanded={isExpanded}
                        aria-controls={panelId}
                      >
                        <span>{box.title}</span>
                        {isExpanded ? <RiArrowUpSLine aria-hidden /> : <RiArrowDownSLine aria-hidden />}
                      </button>
                      {isExpanded && (
                        <div className="dropdown-content" id={panelId}>
                          <p>{box.content}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="carousel-section">
            <Carousel slides={carouselSlides} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
